import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer from './reducers/authReducer';
import userReducer from './reducers/userReducer';
import gameReducer from './reducers/gameReducer';
import companyReducer from './reducers/companyReducer';
import adminReducer from './reducers/adminReducer';
import superStokezReducer from './reducers/superStokezReducer';
import stokezReducer from './reducers/stokezReducer';
import agentReducer from './reducers/agentReducer';
import playerReducer from './reducers/playerReducer';
import drawReducer from './reducers/drawReducer';
import reportingReducer from './reducers/reportingReducer'
import activityLogReducer from './reducers/activityLogReducer';

import settingReducer from './reducers/settingReducer'
import balanceLogReducer from './reducers/balanceLogReducer'

import playerTicketReducer from './reducers/playerTicketReducer';


import { luaScriptReducer } from './reducers/luaReducer';
import {ds_admin_ticketReducer} from './reducers/DSadminReducer';
import {gameWiseSaleReducer} from './reducers/gameWiseReportingReducer'
import {playerWiseSaleReducer} from './reducers/playerWiseReportingReducer'
import {summaryReportReducer} from './reducers/summaryReportReducer'
import {dateWiseSaleReducer} from './reducers/dateWiseReportingReducer'
import playerTicketDetailsReducer from './reducers/playerTicketDetailsReducer'
import dashboardReducer from './reducers/dashboardReducer';
const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  game: gameReducer,
  company: companyReducer,
  admin: adminReducer,
  superStokez: superStokezReducer,
  stokez: stokezReducer,
  agent: agentReducer,
  player: playerReducer,
  draw: drawReducer,
  reporting:reportingReducer,
  activityLog: activityLogReducer,
  setting: settingReducer,
  balanceLog: balanceLogReducer,
  playerTicket: playerTicketReducer,
   luaScripts: luaScriptReducer,
   ds_admin_ticketList:ds_admin_ticketReducer,
   gameWiseSaleReport:gameWiseSaleReducer,
   playerSaleReport:playerWiseSaleReducer,
   dateWiseSaleReport:dateWiseSaleReducer,
   summaryReport:summaryReportReducer,
   playerTicketDetails:playerTicketDetailsReducer,
   dashboard: dashboardReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));
export default store;